import styled from "styled-components"
import {RiMoreLine} from "react-icons/ri"
import Button from "./Button";
import {IoIosArrowForward, IoIosArrowBack} from "react-icons/io"

const Container = styled.div`
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${({lineHeight}) => lineHeight};
    gap: 10px;

    .page-item{
        width: ${({boxSize}) => boxSize};
        height: ${({boxSize}) => boxSize};
        border-radius: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${({theme})=> theme.secondaryBgColor};
        color: ${({theme})=> theme.mainTextColor};
        line-height: 1;
    }

    .active{
        background-color: var(--color-main);
        color: ${({theme}) => theme.reverseMainTextColor};
    }

    .more-icon{
        font-size: 2rem;
        color: ${({theme})=> theme.mainTextColor};
    }
`
    
const Pagination = ({totalPages, handleClick, currentPage, boxSize="40px", lineHeight="100px"}) => {
    
    if(totalPages <= 5)
  return (
    <Container boxSize={boxSize} lineHeight={lineHeight}>
        {
            new Array(totalPages).fill("").map((_,i)=> (
                <button key={i} onClick={() => handleClick(i + 1)} className={currentPage === i + 1 ? "active page-item": "page-item"}>{i + 1}</button>
            ))
        }    
    </Container>
  )
  
  return (
    <Container boxSize={boxSize} lineHeight={lineHeight}>
        {
            currentPage > 1 &&
                <Button type='button' radius="20%" text={<IoIosArrowBack/>} background={"#E85446"} color={"#fff"} handleClick={()=>handleClick(currentPage - 1)} padding='0 10px' width='40px' />
        }
        {
           currentPage >5  &&
           <>
           <button onClick={() => handleClick(1)} className={ "page-item"}>1</button>
           <RiMoreLine className="more-icon"/>
           </>
       }
        {
            (currentPage >= 1 && currentPage <= totalPages) &&
                new Array(totalPages).fill("").map((_,i)=> {
                if(i + 1  >  currentPage - 4 && i + 1 < currentPage + 4){
                    return (
                    <button key={i} onClick={() => handleClick(i + 1)} className={currentPage === i + 1 ? "active page-item": "page-item"}>{i + 1}</button>
                    )
                }
                else{
                    return null
                }
            }
            )
        } 
        {
            currentPage < totalPages -4 &&
            <>
                <RiMoreLine className="more-icon"/>
                <button onClick={() => handleClick(totalPages)} className={currentPage === totalPages ? "active page-item": "page-item"}>{totalPages}</button>
            </>
        }
        {
            currentPage < totalPages && 
        <Button type='button' radius="20%" text={<IoIosArrowForward/>} background={"#E85446"} color={"#fff"} handleClick={()=> handleClick(currentPage + 1)} padding='0 10px' width='40px' />
        }

    </Container>
  )
}

export default Pagination